import React from 'react';
import {
  Box,
  Typography,
  Button,
  IconButton,
  useMediaQuery,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';

interface FileUploadProps {
  files: { file: File | null; name: string }[];
  handleFileChange: (index: number, file: File) => void;
  handleRemoveFile: (index: number) => void;
  handleAddFile: () => void;
}
const FileUpload: React.FC<FileUploadProps> = ({
  files,
  handleFileChange,
  handleRemoveFile,
  handleAddFile,
}) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery('(max-width:600px)');
  return (
    <Box
      sx={{
        width: '100%',
        height: isMobile ? 'auto' : '40%',
        border: '1px solid #ccc',
        mt: 2,
        mb: 2,
        borderRadius: '4px',
        p: '0px',
      }}
    >
      <Typography sx={{ fontSize: 'large', ml: '8px', mt: '4px' }}>
        {t('poiForm.addFiles')}
      </Typography>
      <Box
        sx={{
          maxHeight: isMobile ? 'none' : '65%',
          overflowY: isMobile ? 'visible' : 'auto',
        }}
      >
        {files.map((fileObj, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              mt: 1,
              ml: '6px',
            }}
          >
            <Box
              sx={{
                border: '1px solid #ccc',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1,
                p: 0.5,
                width: '90%',
              }}
            >
              {fileObj.file && !(fileObj.file.name === '') ? (
                <Typography
                  sx={{
                    width: '100%',
                    overflowX: 'auto',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {fileObj.file.name}
                </Typography>
              ) : (
                <Typography sx={{ flexGrow: 1, color: '#62646c' }}>
                  {t('poiForm.noSelectedFile')}
                </Typography>
              )}
              <Button
                variant="contained"
                color="primary"
                component="label"
                sx={{
                  boxShadow: '0',
                  '&:hover': {
                    boxShadow: '0',
                  },
                }}
              >
                {t('poiForm.browse')}
                <input
                  type="file"
                  hidden
                  onChange={(e) => {
                    if (e.target.files && e.target.files[0]) {
                      handleFileChange(index, e.target.files[0]);
                    }
                  }}
                />
              </Button>
            </Box>
            <IconButton onClick={() => handleRemoveFile(index)}>
              <DeleteIcon />
            </IconButton>
          </Box>
        ))}
      </Box>
      <Button
        type="button"
        onClick={handleAddFile}
        startIcon={<AddIcon />}
        sx={{ mt: 2, ml: '6px' }}
      >
        {t('poiForm.addFile')}
      </Button>
    </Box>
  );
};

export default FileUpload;
